import { Button } from "@mui/material";
import { GridColDef, GridLocaleText } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { LoadingBackDrop } from "../../../components/loader";
import { StyledTable } from "../../../components/table/styled-table";
import { getAllOperatorClients } from "../../../services/clients";
import { GetAllOperatorClients } from "../../../services/clients/types";
import { TABLES_LOCALE_TEXT } from "../../../helpers/tables-locale-text";
import { theme } from "../../../helpers/theme";

const OperatorClients = () => {
  const navigate = useNavigate();
  const [operatorClients, setOperatorClients] = useState<
    GetAllOperatorClients[]
  >([]);

  const body = {
    paginacja: null,
    filtr: null,
  };

  const GetAllClients = useQuery(
    ["AllOperatorClients"],
    () => getAllOperatorClients(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setOperatorClients(data.data.payload.klienci);
      },
    }
  );
  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 110,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(`/operator/clients/edit/${params.id}`);
            }}
          >
            Edytuj
          </Button>
        </>
      ),
    },
    // { field: "numer_klienta", headerName: "Numer Klienta", width: 130 },
    { field: "nazwa", headerName: "Nazwa", width: 200 },
    { field: "nip", headerName: "NIP", width: 150 },
    { field: "weryfikacja", headerName: "Weryfikacja", width: 150 },
    { field: "telefon", headerName: "Telefon", width: 150 },
    {
      field: "email",
      headerName: "E-mail",
      width: 250,
    },
    {
      field: "adres",
      headerName: "Adres",
      width: 300,
    },
    {
      field: "info_dodatkowe",
      headerName: "Info Dodatkowe",
      width: 200,
    },
    {
      field: "aktywny",
      headerName: "Aktywny",
      width: 100,
    },
    {
      field: "historia",
      headerName: "Historia Współpracy",
      width: 150,
    },
  ];
  const rows = operatorClients.map((r) => ({
    id: r.id_klient,
    // numer_klienta: r.id_klient,
    nazwa: r.nazwa,
    nip: r.nip,
    weryfikacja: r.weryfikacja === 0 ? "Niezweryfikowany" : "Zweryfikowany",
    telefon: r.telefon,
    email: r.email,
    adres: r.adres_klient
    ? `${r.adres_klient?.kod_pocztowy && r.adres_klient?.kod_pocztowy} ${
        r.adres_klient?.miejscowosc
      }, ${r.adres_klient?.ulica} ${
        r.adres_klient?.numer_budynku ? r.adres_klient.numer_budynku : ""
      }${r.adres_klient?.numer_lokalu ? "/" + r.adres_klient.numer_lokalu : ""}`
    : "Brak Danych",
    info_dodatkowe: r.info_dodatkowe,
    aktywny: r.aktywny === true ? "Tak" : "Nie",
    historia: r.liczba_zamowien === 0 ? "Nie" : "Tak",
  }));

  if (GetAllClients.isLoading || GetAllClients.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <PageWrapper>
      <ClientsContainer>
        <StyledTable
          getRowId={(row:any) => row?.id}
          rows={rows}
          columns={columns}
          autoPageSize
        />
      </ClientsContainer>
    </PageWrapper>
  );
};

export default OperatorClients;
const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const ClientsContainer = styled.div`
  height: 80vh;
  width: 100%;
  display: flex;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
